module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Introduction")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "line-image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "d-para"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("H")])]), _vm._v("ello, friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Welcome to your renovation to stress-free!")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such a bold proclamation, I know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was during the composition of my third and fourth books, "), _c('em', [_vm._v("Well, Girl")]), _vm._v(" and "), _c('em', [_vm._v("Rest, Girl")]), _vm._v(", that I was determined to uncover the root of all my worries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My mental residence, my mind, was decorated just as my physical home was—with decor any good Jesus girl would choose. There was WWJD garb and ornate crosses on the walls. My sound system piped “Amazing Grace” into every room, and my prayer chair was warmed and lit by a classy yet chic Tiffany lamp on an antique side table that had followed me since college. I liked to sit there because it was pretty and quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But if I am to be brutally honest, which you will find I am, despite all the religious paraphernalia in my life, I still struggled with stress and strife. Usually my only hope to reduce my stress was to keep on keeping on despite my misery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Back then my heart song was, “In this life, you will have struggles. Jesus overcame them. And I give up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My “religious” habits, my beliefs about my wrongdoings, and the message of eternal life were conflicting with my tangible experiences. All the good news I knew in my head wasn’t making a difference in my heart and life. I clung to the Scriptures “I can do all things” and “Lord! Help my unbelief!” The clash of exclamations was like a tacky, pleather avocado-green couch and tomatillo-red shag carpet—a mess of retro-industrial-eclectic style with splashes of Pharisee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gross indeed.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("And being the way I am, I spoke up and asked anyone who would ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("listen, “Why does the Bible promise peace, joy, patience, and abundance, but I am so worried, so afraid, so broken?”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What is the other promise? Oh yes! Ask, seek, find.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I didn’t find my answer through wise friendships. It was not any of the dozens of religions I tried. The problem was simply that I was living in the squalor of limited, kind-of, maybe, mostly on Sundays faith and professing rote religious words that were making me bust at the seams of need, want, and growth. No wonder chaos ensued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My struggles went beyond what my limited faith was able to handle. So I went to the house of science. You can call the house of science whatever medical, psychological, or, as in my case, secular study you’d like. I discovered I can often affect my outcome by thinking positively. At first investigating my faith through a scientific lens felt … haunted. And then it felt curious. And then I took my findings to a friend, a wise spiritual gal who is my creative match. I sheepishly reported my discoveries. She pondered and said, “Can you back it up with Scripture?” And I could. So I did.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I pointed to verses about giving “thanks in all circumstances” (1 Thessalonians 5:18), how good people focus on good things and then produce good (Luke 6:45), and how anxiety is eased by focusing on thanking God (Philippians 4:6).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Now my friend and I live stress-free, as do my husband, our children, and our friends.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Want to know how we did it? Come on in and I’ll show you. In fact, one of my spiritual gifts is hospitality. So pull up a chair. Grab a pen, maybe ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("a journal, get cozy, and let me tell you all about this wonderful way to believe, for real, and live in the abundance of peace we were promised. The world will let you down, but Christ and the results of his sacrifice are real.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Here’s the thing. We aren’t just cleaning out a closet or rearranging the living room. This is a gut job. We just keep digging at our spiritual foundation and moving walls in an effort to know how to get from messed to blessed. Lucky us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("God gave you the blueprint. Even better? He gave you the Holy Spirit, who is your personal helper, and Jesus, who not only built the world but is right next to you helping you renovate your life. God is exactly who he says he is. Greater, he called the job of renovating your life “finished.” Do you hear that? God is so certain of your transformation that it’s as if it has already happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So let’s do this! I love a remodel, a new home build, a fresh coat of paint, or a recovered chair so very much. And I am giddy with joy to take this internal renovation journey with you! My husband, Justin, and I have spent the majority of our thirty-plus years (and counting) together making a living in construction management, design, and building. Who would have ever thought that those experiences would directly link to the freedom we were promised?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I propose that is the problem—we try to DIY our faith journey. We deconstruct, try it from this religion or that, fret, chase, and struggle to get to and finally get God so we can have that most coveted promise of peace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Friend, there is no wait for what is already done. There is no struggle to obtain that which is already yours. We are here now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Welcome home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jesus be all over you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/9.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a995d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Introduction.vue
// module id = 72
// module chunks = 0